import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Popconfirm } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCarBattery, faLock, faUnlockAlt, faVolumeUp } from "@fortawesome/free-solid-svg-icons";
import getProgressBar from "views/pages/bikes/helpers/get-progress-bar";
import getChargeIcon from "views/pages/bikes/helpers/get-charge-icon";
// import getGpsIcon from "views/pages/bikes/helpers/get-gps-icon";
import {
  actionLock,
  actionUnLock,
  actionOpenBatteryCover,
  actionVoice, actionUpdateScooterStatus
} from "actions/scooter/scooter/actions";
import moment from "moment";
import { SCOOTER_STATUSES } from "../../../../../data/bike-numeric-statuses";

/*
batteryLvl:
  date: 1658679324119
percent: 81
voltage: 4.19
  [[Prototype]]: Object
charging: false
connected:
  date: 1658662895174
online: true
  [[Prototype]]: Object
gsmSignal: "normal"
id: "862869031539278"
lastBookDate: 0
lastBookUser: null
located:
  latitude: 40.137193333333336
longitude: 44.48914
timestamp: 1658679358870
  [[Prototype]]: Object
locked: true
mileage:
  mileage: 0
remainingMileage: 33040
speed: 0
  [[Prototype]]: Object
qr: "10010366"
state: "ON"
status: "FREE"
type: "NINEBOT_ZK601"
*/


const Info = ({
                item,
                handleClick = false,

                actionLock,
                actionUnLock,
                actionOpenBatteryCover,
                actionVoice,
                actionUpdateScooterStatus,
                onAction
              }) => (
  <div className="card mb-0">
    <table className="table table-hover table-bordered table-striped table-align-middle table-sm mb-0">
      <tbody>
      <tr>
        <td>ID</td>
        <td>
          <Link to={`/scooter/scooter/${item.id}`}>
            {item.id}
          </Link>
        </td>
      </tr>
      <tr>
        <td>QR Code</td>
        <td>{item.qr}</td>
      </tr>
      <tr>
        <td>Speed</td>
        <td>
          {`${item.mileage && item.mileage.speed ? item.mileage.speed : 0} km/h`}
        </td>
      </tr>
      <tr>
        <td>Battery level</td>
        <td>{getProgressBar(item.batteryLvl)}</td>
      </tr>
      <tr>
        <td>Battery Charged</td>
        <td>{item.batteryLvl.percent}%</td>
      </tr>
      <tr>
        <td>Battery</td>
        <td>{item.battery || "Information not available"}</td>
      </tr>
      <tr>
        <td>Millage</td>
        {/* eslint-disable-next-line no-restricted-globals */}
        <td>{(item.mileage && !isNaN(item.mileage.mileage)) ? item.mileage.mileage : "Information not available"}</td>
      </tr>
      <tr>
        <td>Remaining Mileage</td>
        {/* eslint-disable-next-line no-restricted-globals */}
        <td>{(item.mileage && !isNaN(item.mileage.remainingMileage)) ? item.mileage.remainingMileage : "Information not available"}</td>
      </tr>
      <tr>
        <td>Last Ride By</td>
        <td onClick={() => (handleClick ? handleClick() : null)}>
          {item.lastRideUser && item.lastRideUser
            ? <Link to={`/users/${item.lastRideUser}`}>{item.lastRideUser}</Link>
            : "Not Set"}
        </td>
      </tr>
      <tr>
        <td>Last Booked By</td>
        <td onClick={() => (handleClick ? handleClick() : null)}>
          {item.lastBookUser && item.lastBookUser
            ? <Link to={`/users/${item.lastBookUser}`}>{item.lastBookUser}</Link>
            : "Not Set"}
        </td>
      </tr>
      <tr>
        <td>Last Unlocked Admin</td>
        <td>{item.lastUnlockedAdmin}</td>
      </tr>
      <tr>
        <td>Last Unlocked Admin Date</td>
        <td>{item.lastUnlockedAdminDate
          ? moment(item.lastUnlockedAdminDate)
            .format("HH:mm YYYY-MM-DD")
          : "Not Set"}
        </td>
      </tr>
      <tr>
        <td>On Charge</td>
        <td>{getChargeIcon({ charging: item.charging })}</td>
      </tr>
      {/* <tr>
        <td>On GPS</td>
        <td>{getGpsIcon(item.condition)}</td>
      </tr> */}
      <tr>
        <td>SIM Phone</td>
        <td>{item.sim ? item.sim.phone : ""}</td>
      </tr>
      <tr>
        <td>SIM Serial</td>
        <td>{item.sim ? item.sim.serial : ""}</td>
      </tr>
      <tr>
        <td>State</td>
        <td className={item.state === 'ON' ? 'text-success' : 'text-danger'}>{item.state}</td>
      </tr>
      <tr>
        <td>Locked</td>
        <td>
          Press to
          <Popconfirm
            title="Are you sure?"
            onConfirm={() => (item.locked
                ? actionUnLock(item.id, onAction)
                : actionLock(item.id, onAction)
            )}
            placement="bottomRight"
            okText="Yes"
            cancelText="Cancel"
          >
            {item.locked ? (
              <button className="btn btn-sm btn-success ml-1" title="Unlock">
                <FontAwesomeIcon icon={faUnlockAlt}/> Unlock
              </button>
            ) : (
              <button className="btn btn-sm btn-danger ml-1" title="Lock">
                <FontAwesomeIcon icon={faLock}/> Lock
              </button>
            )}
          </Popconfirm>
        </td>
      </tr>
      <tr>
        <td>Actions</td>
        <td>
          <Popconfirm
            title="Are you sure?"
            onConfirm={() => actionOpenBatteryCover(item.id, onAction)}
            placement="bottomRight"
            okText="Yes"
            cancelText="Cancel"
          >
            <button className="btn btn-sm btn-danger ml-2" title="Open battery cover">
              <FontAwesomeIcon icon={faCarBattery}/>
            </button>
          </Popconfirm>
          <Popconfirm
            title="Are you sure?"
            onConfirm={() => actionVoice(item.id, onAction)}
            placement="bottomRight"
            okText="Yes"
            cancelText="Cancel"
          >
            <button className="btn btn-sm btn-info ml-2" title="Voice">
              <FontAwesomeIcon icon={faVolumeUp}/>
            </button>
          </Popconfirm>
        </td>
      </tr>
      <tr>
        <td>Status</td>
        <td>
          <select
            className="form-control form-control-sm"
            value={item.status}
            onChange={(ev) => {
              actionUpdateScooterStatus(item.id, ev.target.value);
              onAction(0);
            }}
          >
            {SCOOTER_STATUSES
              .map(status => (
                <option
                  value={status}
                  key={status}
                >
                  {status}
                </option>
              ))}
          </select>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
);

const mapStateToDispatch = dispatch => ({
  actionLock: bindActionCreators(actionLock, dispatch),
  actionUnLock: bindActionCreators(actionUnLock, dispatch),
  actionOpenBatteryCover: bindActionCreators(actionOpenBatteryCover, dispatch),
  actionVoice: bindActionCreators(actionVoice, dispatch),
  actionUpdateScooterStatus: bindActionCreators(actionUpdateScooterStatus, dispatch),
});

export default connect(null, mapStateToDispatch)(Info);



// WEBPACK FOOTER //
// ./src/views/pages/scooter/scooter/single/info.js